import s from "./teacher-sell-card.module.scss";
import { Stats } from "./stats";
import { NearestAppointment } from "./nearest-appointment";
import { CTA } from "./CTA";
import { StartChatButton } from "@features/messanger/start-chat";

export const TeacherSellCard = ({ teacher, rating }) => {	
  return (
    
    <div className={s.wrapper}>
      <div className={s.content}>
        <Stats isTrial={teacher?.trial_enabled} isDiscounted={(!teacher?.free_first_lesson && teacher?.first_lesson_discount > 0)} first_lesson_discount={teacher?.first_lesson_discount} rating={rating} reviews={teacher?.reviews} appointments_count={teacher?.appointments_count} grade={teacher?.grade}/>
        <div className={s.actionsWrapper}>
          <NearestAppointment nearest_available_time={teacher?.nearest_available_time}/>
          <CTA isTrial={teacher?.trial_enabled} free_first_lesson={teacher?.free_first_lesson} first_lesson_discount={teacher?.first_lesson_discount} teacher_id={teacher?.teacher_slug}/>
					<StartChatButton teacherId={teacher?.id} className={s.startChatButton}/>
        </div>
      </div>
    </div>
  );
};
